import React from 'react';
import { Icon } from './Icon.js';
export const IconEarphoneRightSound = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 8V19H17V11L13 10V3H16C18.7614 3 21 5.23858 21 8Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M11 18C8.79086 18 7 19.7909 7 22", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", fill: "none" }),
        React.createElement("path", { d: "M11 14C6.58172 14 3 17.5817 3 22", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", fill: "none" })));
};
//# sourceMappingURL=IconEarphoneRightSound.js.map